module.exports = __webpack_public_path__ + "static/05-493ee80156ab28666549e86f81e1356f.jpg";